module.exports = __webpack_public_path__ + "img/Bent Tongue.a12fa07e.png";